import React, { useEffect } from "react";
import Dashboard from "../Dashboard";
import Menu from "../Menu";
import Header from "./Header";
import { useLocation } from "react-router-dom";
import { useStateValue } from "../../context";
import { getTemplate } from "../../middleware";
import { attemptGetTemplate, getTemplateSuccess } from "../../context/actions";
import { Loader } from "../../../core/Loader";

const Main = () => {
  console.log("karen testing");
  const [state, dispatch] = useStateValue();
  const location = useLocation();
  const templateId = location.pathname.split("/").pop();

  useEffect(() => {
    let didCancel = false;

    const fetchTemplate = async () => {
      try {
        dispatch(attemptGetTemplate());
        const result = await getTemplate(templateId);
        !didCancel && dispatch(getTemplateSuccess(result));
      } catch (error) {
        console.log("error", error);
      }
    };

    fetchTemplate();
    return () => (didCancel = true);
  }, [dispatch, templateId]);

  // TODO: Re-implement navigation blocking using useEffect with beforeunload event
  // React Router v6 removed Prompt component
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (state.isEdited) {
        e.preventDefault();
        e.returnValue = '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [state.isEdited]);

  if (!state.layout.fetched) return <Loader />;

  return (
    <div
      className={`main container ${
        state.isLoading || state.isHeaderDisable ? "eventDisabled" : ""
      }`}
    >
      <Header />
      <div className="main-body row">
        <Dashboard />
        <Menu />
      </div>
    </div>
  );
};

export default Main;
